// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GIDS","icon":"styles_icon__1Je5S"};